export enum JobBoardAttachmentTypeEnum {
  LOGO_IMAGE= 'logo',
  HEADER_IMAGE= 'header',
}
